module.exports = __webpack_public_path__ + "img/6.a8793792.jpg";